import { render, staticRenderFns } from "./PortalMoneyInput.vue?vue&type=template&id=40f8c3ea&scoped=true&"
import script from "./PortalMoneyInput.vue?vue&type=script&lang=ts&"
export * from "./PortalMoneyInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f8c3ea",
  null
  
)

export default component.exports